import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { firstListItem } from '@/constants/defaultValues';
import AuthApi from '@/api/auth/auth';

export const login = createAsyncThunk(
  'user/login',
  async (params, thunkAPI) => {
    try {
      const { userName, password, isAzure, token } = params;
      let response = null;
      if (!isAzure) {
        response = await AuthApi.Login(userName, password);
      } else {
        response = await AuthApi.AzureLogin(userName, token);
      }
      if (response && response?.data && response?.data?.data) {
        const user = response?.data?.data;
        console.log('UserSlice: Raw Login Response Data:', user); // DEBUG LOG

        // Robust ID extraction
        const userId = user?.employeeInfo?.id ?? user?.employeeDetails?.id ?? user?.id;
        const userTypeId =
          user?.employeeInfo?.userTypeID ??
          user?.employeeDetails?.userTypeID ??
          user?.userTypeID;

        return {
          userName: user.userName,
          accessToken: user.accessToken,
          refreshToken: user.refreshToken,
          id: userId, // Use extracted ID
          userTypeID: userTypeId,

          // Preserve raw payload sections used by saveTokensToLocalStorage()
          employeeInfo: user?.employeeInfo,
          employeeConfigration: user?.employeeConfigration,
          shortcuts: user?.shortcuts,
          assignRoles: user?.assignRoles,

          // Legacy flattened fields (keep old shape working for non-azure responses)
          employeeNo: user?.employeeDetails?.employeeNo,
          nameAr: user?.employeeDetails?.nameAr,
          nameEn: user?.employeeDetails?.nameEn,
          companyID: user?.employeeDetails?.companyId,
          managerID: user?.employeeDetails?.managerID,
          employeeImage: user?.employeeDetails?.employeeImage,
          managerImage: user?.employeeDetails?.managerImage,
          managerNo: user?.employeeDetails?.managerNo,
          managerNameAr: user?.employeeDetails?.managerNameAr,
          managerNameEn: user?.employeeDetails?.managerNameEn,
          role: user?.employeeDetails?.role?.trim(),
          isManager: user?.employeeDetails?.isManager,
          designtion: user?.employeeDetails?.desinationName,
          groupIds: user?.employeeDetails?.groupIds,
          isHr: user?.employeeDetails?.isHr,
          isSecurity: user?.employeeDetails?.isSecurity,
          lang: user?.employeeDetails?.lang,
          isEntityPrivilege: user?.employeeDetails?.isEntityPrivilege
        };
      }
      return thunkAPI.rejectWithValue(
        response?.data?.message ||
        response?.data?.errDescription ||
        response?.data?.errMessage ||
        response?.data?.errCode ||
        response?.data?.errorCode ||
        'An error occurred'
      );
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  userDetails: {},
  loading: false,
  error: '',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearAuth: (state, action) => {
      state.userDetails = {};
      state.loading = initialState.loading;
      state.error = initialState.error;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetails = action.payload;
        state.error = '';
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.userDetails = {};
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export const { clearAuth } = userSlice.actions;
export default userSlice.reducer;
